"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _styles = require("./styles");
var _getCurrentSlideIndex = _interopRequireDefault(require("./_getCurrentSlideIndex"));
var _getSlideWidth = _interopRequireDefault(require("./_getSlideWidth"));
var _Hideable = _interopRequireDefault(require("../Hideable"));
var _excluded = ["children", "onChangeSlide", "infiniteLoop", "useSkeleton", "imagesLoaded"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// TODO:
//  - consider adding a stateless version for more precise control
//    (i.e. letting parent component track/update the current slide index)
//  - add left/right arrows on desktop
var DotCarousel = function DotCarousel(_ref) {
  var children = _ref.children,
    onChangeSlide = _ref.onChangeSlide,
    infiniteLoop = _ref.infiniteLoop,
    useSkeleton = _ref.useSkeleton,
    imagesLoaded = _ref.imagesLoaded,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dotIndex = _useState2[0],
    setDotIndex = _useState2[1];
  var slidesRef = (0, _react.useRef)(null);

  // NOTE: consider throttling this if necessary
  var handleScroll = (0, _react.useCallback)(function () {
    var nextDotIndex = (0, _getCurrentSlideIndex["default"])(slidesRef.current);
    setDotIndex(nextDotIndex);
    onChangeSlide(nextDotIndex);
  }, [children, infiniteLoop]);
  return /*#__PURE__*/_react["default"].createElement(_styles.DotCarouselRoot, rest, /*#__PURE__*/_react["default"].createElement(_styles.SlidesWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.Slides, {
    ref: slidesRef,
    onScroll: handleScroll
  }, children)), /*#__PURE__*/_react["default"].createElement(_Hideable["default"], {
    isHidden: !useSkeleton
  }, /*#__PURE__*/_react["default"].createElement(_styles.Dots, null)), /*#__PURE__*/_react["default"].createElement(_Hideable["default"], {
    isHidden: useSkeleton
  }, /*#__PURE__*/_react["default"].createElement(_styles.Dots, null, _react.Children.map(children, function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(_styles.Dot, {
      active: index === dotIndex,
      onClick: function onClick() {
        var slideWidth = (0, _getSlideWidth["default"])(slidesRef.current);
        slidesRef.current.scroll({
          left: slideWidth * index,
          behavior: 'smooth'
        });
        setDotIndex(index);
        onChangeSlide(index);
      }
    });
  }))));
};
DotCarousel.propTypes = {
  children: _propTypes["default"].node.isRequired,
  onChangeSlide: _propTypes["default"].func,
  infiniteLoop: _propTypes["default"].bool,
  scrollMode: _propTypes["default"].oneOf([
  // Slides will take up the full carousel
  'discrete',
  // Slides won't take up the full carousel,
  // allowing the user to see parts of neighboring slides.
  // Still uses snap-scrolling.
  'peek',
  // continuous scrolling
  'continuous']),
  useSkeleton: _propTypes["default"].bool,
  imagesLoaded: _propTypes["default"].bool
};
DotCarousel.defaultProps = {
  infiniteLoop: false,
  onChangeSlide: _noop["default"],
  scrollMode: 'discrete',
  useSkeleton: false,
  imagesLoaded: true
};
var _default = DotCarousel;
exports["default"] = _default;
//# sourceMappingURL=DotCarousel.js.map